import * as Avatar from '@radix-ui/react-avatar';
import { useEffect, useState } from 'react';

interface AvatarProps {
  avatar: string;
}

const AvatarContainer = ({ avatar }: AvatarProps) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log(avatar);
  }, [avatar]);

  return (
    <div style={{ display: 'flex', gap: '20px' }}>
      <div
        style={{
          position: 'relative',
          height: '80px',
          width: '80px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Outer Gradient Border */}
        <div
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            borderRadius: '50%',
            padding: '4px',
            background: 'linear-gradient(135deg, #f58529, #dd2a7b, #8134af, #515bd4)',
          }}
        >
          <div
            style={{
              height: '100%',
              width: '100%',
              borderRadius: '50%',
              backgroundColor: 'white',
            }}
          ></div>
        </div>

        {/* Avatar */}
        <Avatar.Root
          style={{
            position: 'relative',
            height: '64px',
            width: '64px',
            borderRadius: '50%',
            overflow: 'hidden',
          }}
        >
          {isLoading && (
            <div
              style={{
                height: '100%',
                width: '100%',
                backgroundColor: '#d1d5db',
                animation: 'pulse 1.5s infinite',
              }}
            ></div>
          )}
          <Avatar.Image
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
              borderRadius: '50%',
              display: isLoading ? 'none' : 'block',
            }}
            src={`https://storage.googleapis.com/zk-partners-assets/${avatar}`}
            alt="Avatar"
            onLoad={() => setIsLoading(false)}
          />
          <Avatar.Fallback
            style={{
              display: 'flex',
              height: '100%',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#d1d5db',
              fontSize: '15px',
              fontWeight: '500',
              color: 'black',
              borderRadius: '50%',
            }}
            delayMs={600}
          >
            ML
          </Avatar.Fallback>
        </Avatar.Root>
      </div>
    </div>
  );
};

export default AvatarContainer;
